import { getAppBasedEnvironment } from './app-based-environment';
import { toValidTealiumEnvironment } from './tealium-environment';

export const COOKIE_NAME_AGENCY_CODE = 'AgenturNummer';
export const COOKIE_NAME_CONSENT_PRESET = 'consentPreset';

export const TRACKER_ENABLED =
  process.env.NEXT_PUBLIC_TRACKER_ENABLED !== 'false' &&
  process.env.NEXT_PUBLIC_TRACKER_ENABLED !== '0';

export const TRACKER_LOG =
  process.env.NEXT_PUBLIC_TRACKER_LOG === 'true' ||
  process.env.NEXT_PUBLIC_TRACKER_LOG === '1';

export const TRACKER_ACCOUNT =
  process.env.NEXT_PUBLIC_TRACKER_ACCOUNT ??
  process.env.NEXT_PUBLIC_TEALIUM_ACCOUNT ??
  'tui-cruises';

export const TRACKER_PROFILE =
  process.env.NEXT_PUBLIC_TRACKER_PROFILE ??
  process.env.NEXT_PUBLIC_TEALIUM_PROFILE ??
  'main';

export const TRACKER_ENVIRONMENT = toValidTealiumEnvironment(
  process.env.NEXT_PUBLIC_TRACKER_ENVIRONMENT ??
    process.env.NEXT_PUBLIC_TEALIUM_ENV_FLAG ??
    getAppBasedEnvironment(),
);

export const TRACKER_MOCK_MESSAGE_CLIENT =
  process.env.NEXT_PUBLIC_TRACKER_MOCK_MESSAGE_CLIENT === 'true' ||
  process.env.NEXT_PUBLIC_TRACKER_MOCK_MESSAGE_CLIENT === '1';
